// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-vessel-eq /deep/ .el-submenu__title {\n  border-bottom: none !important;\n}\n.tab-vessel-eq .warn-label .el-form-item__label {\n  color: orange !important;\n}\n", ""]);
// Exports
module.exports = exports;
